import { forwardRef, InputHTMLAttributes } from 'react';
import { LucideIcon } from 'lucide-react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  leftIcon?: LucideIcon;
  rightIcon?: LucideIcon;
  rightButton?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, leftIcon: LeftIcon, rightIcon: RightIcon, rightButton, className = '', ...props }, ref) => {
    const inputId = props.id ?? props.name;
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-text-secondary mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {LeftIcon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted">
              <LeftIcon className="w-4 h-4" />
            </div>
          )}
          <input
            id={inputId}
            ref={ref}
            className={`
              input-base w-full
              ${LeftIcon ? 'pl-10' : ''}
              ${RightIcon || rightButton ? 'pr-10' : ''}
              ${error ? 'border-loss focus:border-loss focus:shadow-glow-loss' : ''}
              ${className}
            `}
            {...props}
          />
          {RightIcon && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted">
              <RightIcon className="w-4 h-4" />
            </div>
          )}
          {rightButton && (
            <div className="absolute right-0 top-0 h-full flex items-center">
              {rightButton}
            </div>
          )}
        </div>
        {error && <p className="mt-1 text-sm text-loss">{error}</p>}
        {!error && hint && <p className="mt-1 text-sm text-text-muted">{hint}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
